<template lang="pug">
div
  template(v-if="!showMobile")
    topbar
    .conbox
      .hometabs
        tabList
  .tabbox
    .gbox-wrap.epic.aaa
      epicGame
  footerInfo
</template>
<script>
import topbar from '@/views/default/_topBar.vue'
import tabList from '@/views/default/_tabs.vue'
import footerInfo from '@/views/default/_footer.vue'
import epicGame from '@/component/slot/_epicGame.vue'
import config from "@/config";
export default {
  components:{
    topbar,
    tabList,
    footerInfo,
    epicGame
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      showMobile: false,
			imgUrl: config.imageUrl,
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    // getAnnBefore() {
    //   return this.$store.state.user.annBeforeLog
    // },
  },
  created(){
    this.checkSize()
    this.getSeo()
  },
  // metaInfo(){
  //   return{
  //     title: this.$store.state.user.homeSeo.meta_title,
  //     meta:[
  //       {vmid: "og:title",name: 'og:title', content: this.$store.state.user.homeSeo.meta_title},
  //       {vmid: "description",name: 'description', content: this.$store.state.user.homeSeo.meta_desc},
  //       {vmid: "og:description",name: 'og:description', content: this.$store.state.user.homeSeo.meta_desc},
  //       {vmid: "author",name: 'author', content: this.$store.state.user.homeSeo.meta_author},
  //       {vmid: "canonical",name: 'canonical', content: this.$store.state.user.homeSeo.meta_canonical},
  //       {vmid: "keywords",name: 'keywords', content: this.$store.state.user.homeSeo.meta_keywords},
  //       {vmid: "language",name: 'lang', content: this.$store.state.user.homeSeo.meta_lang},
  //       {vmid: "url",name: 'url', content: this.$store.state.user.homeSeo.meta_url},
  //       {vmid: "og:url",name: 'og:url', content: this.$store.state.user.homeSeo.meta_url},
  //     ],
  //     link:[
  //       { rel: 'image_src', href: this.imgUrl+ this.$store.state.user.homeSeo.meta_image_url},
  //     ]
  //   }
    
  // },
  mounted(){
    // this.getSeo()
    // if(!this.isLoggedIn){
    //   console.log(this.getAnnBefore)
    //   if(this.$store.state.user.annBeforeLog === true){
    //     $("#modal-banner").modal("show");
    //   }
    // }
    var vm = this
    $(window).resize(function () {
      vm.checkSize()
    });
  },
  methods:{
    getSeo(){
      let page_name = "home_page"
      this.$store
        .dispatch("user/getSeo", {page_name})
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
            // response.data[0].page_name = page_name
            if(response.data.length > 0){
              // this.$store.dispatch("user/seoInfo", response.data[0])
            }
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
        });
    },
    // checkAnn(){
    //   this.$store
    //     .dispatch("user/getAnnBanner")
    //     .then(response => {
    //       this.loading = false;
    //       this.feedback.success = response.success
    //       if (this.feedback.success == true) {
    //         if(response.annBeforeLog === true){
    //           if(!this.isLoggedIn){
    //             $("#modal-banner").modal("show");
    //           }
    //         }
    //       } else {
    //         if((typeof response.status) != 'object'){
    //           this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
    //         }       
    //       }
    //     })
    //     .catch(response => {
    //       this.loading = false;
    //       var vm = this;
    //       if((typeof response.status) != 'object'){
    //         this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
    //       }
    //     });
    //   // if(!this.$store.getters.isLoggedIn){
    //   //   if(this.$store.state.user.annBeforeLog === true){
    //   //     $("#modal-banner").modal("show");
    //   //   }
    //   // }
    // },
    checkSize(){
      if ($(window).width() < 681) {
        this.showMobile = true
      }else{
        this.showMobile = false
      }
    },
  }
}
</script>